import { Navigate, Outlet } from "react-router";
import { useAuthStore } from "@pos/shared/stores";
import { LoginHero } from "@/components/login/LoginHero";

export function AuthLayout() {
  const token = useAuthStore((s) => s.token);

  if (token) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen">
      {/* Hero Panel */}
      <div className="relative hidden overflow-hidden bg-[#0c1425] lg:flex lg:w-[58%]">
        {/* Atmospheric gradients */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_25%_48%,oklch(0.18_0.04_250),transparent)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_50%_at_85%_85%,oklch(0.14_0.03_270),transparent)]" />

        {/* Dotted pattern overlay */}
        <div
          className="absolute inset-0 opacity-[0.12]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='10' cy='10' r='1' fill='%23fff'/%3E%3C/svg%3E")`,
          }}
        />

        <div className="relative z-10 flex w-full flex-col justify-center px-16 py-12 xl:px-20">
          <LoginHero />
        </div>
      </div>

      {/* Form Panel */}
      <div className="flex flex-1 flex-col bg-background">
        {/* Mobile header */}
        <div className="flex items-center gap-2.5 px-6 pt-8 lg:hidden">
          <img src="/logo.png" alt="XPOS" className="h-8 w-auto" />
        </div>

        <div className="flex flex-1 items-center justify-center px-6 py-10 lg:px-12">
          <div className="w-full max-w-[400px]">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
